fx.ns("models", class EmptyMedia extends fx.Media {

	constructor(data)
	{
        super({id:0});
        
        this._originalData = data;
        this.isBlob = false;
        this.loaded = true;

        this.image = {width:1000, height : 1000, src : this.URL};
	}

    get storable(){
        return false;
    }

	
	get URL()
    {
        if (this._originalData instanceof models.ThemeLayoutComponent)
            return fx.assets.layoutPlaceHolder.content;
        else
            return fx.assets.imagePlaceHolder.content;
    }


    fetch(rotation, callback)
    {
        if (!this.image)
            return;

        if (typeof rotation == "function")
            callback = rotation;
        
            
        callback({url : this.URL, width : this.image.width, height : this.image.height});
        
    }
	
	
});